module.exports = __webpack_public_path__ + "static/img/equipment_ttl.b99e321.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/equipment_ttl.svg
// module id = wckA
// module chunks = 0